import { jsx } from "panel";
import { InputEl } from "common/components/input";
import { InputSize, InputType, ValidationStatus } from "common/components/input/types";
import { EntryPart } from "common/query-builder/query-entry-section/types";
import { BaseEntryRowEl } from "../base/template";
export function FormulaEntryRowEl(entryRowProps) {
  const { section, entry, index } = entryRowProps;
  const selectorRenderer = () => {
    return /* @__PURE__ */ jsx("div", {
      sel: `.mp-query-entry-selector.formula-name`
    }, entry.event.label);
  };
  const bodyRowRenderer = () => {
    return /* @__PURE__ */ jsx("div", {
      sel: `.formula-definition-section`
    }, /* @__PURE__ */ jsx(InputEl, {
      sel: `.formula-definition`,
      attrs: {
        type: InputType.Text,
        size: InputSize.Medium,
        placeholder: `eg. (A+B)/(A-B) * 100`,
        "auto-focus": section.state.openEntry.index === index && section.state.openEntry.part === EntryPart.Value,
        ...entry.event.error && {
          "validation-status": ValidationStatus.Invalid,
          "error-message": entry.event.error
        }
      },
      props: {
        value: entry.event.value || ``
      },
      on: {
        keydown: (ev) => this.handleDefinitionKeydown(ev),
        input: (ev) => this.handleDefinitionInput(ev),
        blur: (ev) => this.handleDefinitionBlur(ev),
        focus: () => this.handleDefinitionFocus()
      }
    }));
  };
  return /* @__PURE__ */ jsx(BaseEntryRowEl, {
    index,
    el: section,
    entry,
    isPlaceholder: false,
    rowRenderer: {
      selectorRenderer,
      bodyRowRenderer
    }
  });
}
